import { Component, computed, inject, input, model, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Navlink } from '@shared/models/navlink.model';

const BREAKPOINT_LG_WIDTH = 992;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  private readonly router = inject(Router);

  navLinks = input.required<Navlink[]>();

  brandLink = computed<string | undefined>(() => this.navLinks().find(link => !link.header)?.path);
  pharmacies = input<Navlink[]>();
  chains = input<Navlink[]>();
  bottomLinks = input<Navlink[]>();
  isLoading = input<boolean>(false);
  isClosed = model<boolean>(false);
  loadingCount = input<number>(0);

  pharmacySearch = signal('');
  chainSearch = signal('');

  isPharmacyOpen = signal<boolean>(this.router.url.includes('/pharmacy'));
  isChainOpen = signal<boolean>(this.router.url.includes('/chain'));

  pharmacySearchEnabled = computed<boolean>(() => (this.pharmacies() ?? []).length > 10);
  chainSearchEnabled = computed<boolean>(() => (this.chains() ?? []).length > 10);

  isPharmacySectionOpen = signal(!this.isChainOpen() && !this.isPharmacyOpen());
  isChainSectionOpen = signal(false);

  filteredPharmacies = computed<Navlink[]>(() => (this.pharmacies() ?? []).filter(this.filterLinkByLowercase(this.pharmacySearch())));
  filteredChains = computed<Navlink[]>(() => (this.chains() ?? []).filter(this.filterLinkByLowercase(this.chainSearch())));
  placeHolderItems = computed(() => Array.from(Array(this.loadingCount()).keys()));

  ngOnInit() {
    this.isClosed.set(window.innerWidth <= BREAKPOINT_LG_WIDTH);
  }

  protected linkClicked() {
    if (window.innerWidth <= BREAKPOINT_LG_WIDTH) {
      this.isClosed.set(true);
      this.isPharmacySectionOpen.set(false);
      this.isChainSectionOpen.set(false);
    }

    setTimeout(() => {
      this.isPharmacyOpen.set(this.router.url.includes('/pharmacy'));
      this.isChainOpen.set(this.router.url.includes('/chain'));
    });
  }

  private filterLinkByLowercase(searchString: string): (link: Navlink) => boolean {
    return link =>
      (link.subLabel ?? '').toLowerCase().includes(searchString.toLowerCase()) ||
      (link.label ?? '').toLowerCase().includes(searchString.toLowerCase());
  }
}
